import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import UsersPage from 'components/pages/settings/UsersPage';

export default function UsersApp({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <UsersPage {...wrappedProps} />
      </AppWrapper>
    </QueryClientProvider>
  );
}
